let ctx: AudioContext | null = null;
function getCtx(){
  ctx ||= new AudioContext();
  return ctx;
}
// iOS suspends/interrupts the AudioContext when the tab is backgrounded and won't
// resume it on a visibilitychange alone — it requires resume() inside a real user
// gesture (touchend/click). Without this, sound silently dies after switching apps.
if (typeof document !== "undefined") {
  const resume = () => { if (ctx && ctx.state === "suspended") ctx.resume(); };
  document.addEventListener("touchend", resume, { passive: true });
  document.addEventListener("click", resume);
}
export function sfx(kind: "click"|"live"|"blank"|"item", muted: boolean) {
  if (muted) return;
  const ctx = getCtx();
  const o = ctx.createOscillator(), g = ctx.createGain();
  const now = ctx.currentTime;
  const f = kind === "live" ? 75 : kind === "blank" ? 180 : kind === "item" ? 520 : 240;
  o.frequency.setValueAtTime(f, now); o.frequency.exponentialRampToValueAtTime(Math.max(35, f * 0.55), now + (kind === "live" ? 0.24 : 0.09));
  g.gain.setValueAtTime(0.0001, now); g.gain.exponentialRampToValueAtTime(kind === "live" ? 0.18 : 0.055, now + 0.01); g.gain.exponentialRampToValueAtTime(0.0001, now + (kind === "live" ? 0.28 : 0.12));
  o.connect(g).connect(ctx.destination); o.start(now); o.stop(now + 0.3);
}
